import React, { useState, useEffect, useMemo } from 'react';
import * as R from 'ramda';
import { Route } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { postJSONPS } from '../../lib/utils/fetch';
import { composePS } from '@cd/pipe';
import { either } from '../../lib/utils/utils';

import CenterProgress from '../../CenterProgress';
import { css } from '@emotion/react';
import QRCode from './QRCode';

const postGetAppVersion = () =>
	composePS(postJSONPS)('GET', `/config/get/app/version`, {});

const getTitle = pathname => {
	switch (pathname) {
		case '/index':
			return 'Inspector';

		case '/results':
			return 'Results';

		case '/login':
			return 'Login';

		default:
			return 'eLocal';
	}
};

const searchStyles = css({
	display: 'flex',
	alignItems: 'center',
	color: 'green',
	marginLeft: 'auto',
	marginRight: '4px'
});

const Search = ({ searchValue, onSearchValue }) => (
	<div css={searchStyles}>
		<SearchIcon />
		<TextField
			inputProps={{
				sx: { padding: '4px', maxWidth: 160 },
				'aria-label': 'search'
			}}
			placeholder="Search…"
			value={searchValue}
			onChange={onSearchValue}
		/>
	</div>
);

const DASHBOARD_PATH = '/dashboard/view';

const IndexAppBar = ({
	onOpenNavDrawer,
	searchValue,
	onSearchValue,
	navList
}) => {
	const history = useHistory();
	const location = useLocation();
	const [currentFormTitle, setCurrentFormTitle] = useState(
		getTitle(location.pathname)
	);
	const [appVersion, setAppVersion] = useState(undefined);

	useEffect(() => {
		const unlisten = history.listen(({ pathname }) => {
			setCurrentFormTitle(getTitle(pathname));
			onSearchValue({ target: { value: '' } });
		});

		postGetAppVersion().then(
			either(console.log, v => setAppVersion(v))
		);

		return unlisten;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const searchFormList = useMemo(
		() =>
			R.compose(
				R.pluck('href'),
				R.filter(R.propEq('hasSearch', true))
			)(navList) || [],
		[navList]
	);

	if (!navList || navList.length === 0) {
		return <CenterProgress />;
	}

	const url = new URL(window.location.href);
	const isDashBoard = url.pathname === DASHBOARD_PATH;

	return (
		<AppBar position="static">
			<Toolbar sx={{ pr: 0, pl: 0, flex: '0 0 auto' }}>
				<IconButton
					color="inherit"
					aria-label="Open drawer"
					onClick={onOpenNavDrawer}
					size="large">
					<MenuIcon />
				</IconButton>
				<Typography variant="h6" color="inherit" noWrap>
					{currentFormTitle}
				</Typography>
				<Typography
					css={{ marginLeft: '4px', marginTop: '-8px' }}
					variant="caption"
					color="secondary"
					noWrap>
					{appVersion}
				</Typography>
				{isDashBoard ? <QRCode /> : null}
				<Route
					path={searchFormList}
					render={() => (
						<Search searchValue={searchValue} onSearchValue={onSearchValue} />
					)}
				/>
			</Toolbar>
		</AppBar>
	);
};

export default IndexAppBar;
